var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefreshArrows(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66675 8.33333C1.66675 8.33333 1.76785 7.62563 4.69678 4.6967C7.62571 1.76777 12.3744 1.76777 15.3034 4.6967C16.3411 5.73443 17.0112 7.0006 17.3136 8.33333M1.66675 8.33333V3.33333M1.66675 8.33333H6.66675M18.3334 11.6667C18.3334 11.6667 18.2323 12.3744 15.3034 15.3033C12.3744 18.2322 7.62571 18.2322 4.69678 15.3033C3.65905 14.2656 2.98899 12.9994 2.6866 11.6667M18.3334 11.6667V16.6667M18.3334 11.6667H13.3334",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshArrows);
export default __webpack_public_path__ + "static/media/refresh-arrows.53a4cb74424efb89f5ba19c750d4e918.svg";
export { ForwardRef as ReactComponent };